<template lang="html">

    <div class="cover-popup -middle row-center">

      <div class="popup">
        
        <a @click="$emit('cerrarPopup')" class="close">✕</a>

        <h2 class="title-pop">DOCUMENTACIÓN PENDIENTE DE FIRMA</h2>

        <p v-if="empresa">Al participar en el Programa de Intermediación Laboral subvencionado por la Junta de Castilla y León (Servicio Público de Empleo de Castilla y León) Vd. se compromete a entrevistar al candidato debiendo firmar el siguiente documento.</p>
        <p v-else>Al inscribirte en esta oferta te comprometes a formar parte del Programa de Intermediación Laboral subvencionado por la Junta de Castilla y León (Servicio Público de Empleo de Castilla y León) y a acudir a la entrevista en caso de ser convocado y firmar el justificante de la misma. Debes firmar los siguientes documentos que se ponen a tu disposición:</p>

        <div class="upload-zone row-start ais" style="margin-top:15px;margin-bottom:10px;">
          <div class="texts">
            <template v-for="(encuesta, key) in Object.entries(documentosPendientesFirma)">
              <div class="contenedor-input select-documento doc-firmable" style="text-align: left;cursor:auto;">
                <span>{{encuesta[0]}}</span>
              </div>
              <div class="contenedor-input nuevo-documento capa-firma-doc-firmable">
                <arrow-link class="arrow-link" :text="'FIRMAR'" :to="encuesta[1]" :external="true" :blank="true"></arrow-link>
              </div>
            </template>
          </div>
        </div>

        <!-- <p v-if="empresa"><b>Una vez firmado podrá acceder al CV.</b>​</p>
        <p v-else><b>Tu CV no será visible a la empresa, hasta que no estén todos los documentos firmados.</b>​</p> -->
        <p v-if="!empresa"><b>Tu CV no será visible a la empresa, hasta que no estén todos los documentos firmados.</b>​</p>

      </div>
    </div>

</template>

<script lang="js">

  import {mapGetters,mapActions} from 'vuex'

  import router from '@/router';

  import arrowLink from '@/components/parts/icons/arrow-link'

  export default  {
    name: 'popup-rgpd',
    props : ['documentosPendientesFirma','empresa'],
    data(){
      return{
        loading : false
      }
    },
    computed :{
      ...mapGetters({
        textoRGPD : 'getTextoRGPD',
        colors : 'basicColors',
        style : 'getStyles',
        isEmpresa : 'isEmpresa'
      }),
      ownstyle : function(){
        return {
          popup :{
            background: this.colors.white
          }
        }
      }
    },
    methods :{
      ...mapActions(['guardarRGPD','guardarRGPDEncuesta']),
      sendguardarRGPD : function(){
        if(this.$route.name == 'ficha_encuestas' | this.$route.name == 'acceso_encuesta'){
          this.loading = true;
          this.guardarRGPDEncuesta(this.$route.params.id).then(r => {
            if(this.$route.name == 'acceso_encuesta'){
              router.push('/encuestas/'+this.$route.params.id);
            }
            this.loading = false;
          })
        }else{
          this.loading = true;
          this.guardarRGPD((this.how == 'empresas')).then(r => {
            router.push('/');
            this.loading = false;
          })
        }
      }
    },
    components :{
      'arrow-link': arrowLink
    }
  }
</script>

<style scoped lang="scss">
  .popup-rgpd {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.5);
    z-index: 20;
    padding: 20px;
  }


  
  
  .contenedor-texto{
    overflow: scroll;
    overflow-x: hidden;
    max-height: 100%;
    padding: 0 10px;
    width: 100%;

/*    &::-webkit-scrollbar {
      width: 2px;
      height: 2px;
    }
    &::-webkit-scrollbar-button {
      width: 0px;
      height: 0px;
    }
    &::-webkit-scrollbar-thumb {
      background: #ffffff;
      border: 0px none #ffffff;
      border-radius: 50px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #ffffff;
    }
    &::-webkit-scrollbar-thumb:active {
      background: #000000;
    }
    &::-webkit-scrollbar-track {
      background: #666666;
      border: 0px none #ffffff;
      border-radius: 50px;
    }
    &::-webkit-scrollbar-track:hover {
      background: #666666;
    }
    &::-webkit-scrollbar-track:active {
      background: #333333;
    }
    &::-webkit-scrollbar-corner {
      background: transparent;
      }*/
    }

    .bottom-container{
      
      font-weight: 300;
      width: 100%;

      .enlace{
        margin-bottom: 15px;
        width: 100%;
        display: inline-block;
      }

      .enlace a{
        text-decoration: underline;
      }
    }

  </style>



// WEBPACK FOOTER //
// src/components/views/documentacion/popup-documentacion-firmable.vue